import { z } from 'zod';
import { Channel } from '.';

export const PurchaseOrderChannelSchema = {
  metricsUpdated: z.object({
    productCost: z.number().default(0),
    arExpenses: z.number().default(0),
    apExpenses: z.number().default(0),
    totalCost: z.number().default(0),
    totalRevenue: z.number().default(0),
    realizedRevenue: z.number().default(0),
    grossProfit: z.number().default(0),
    netProfit: z.number().default(0),
    grossProfitMargin: z.number().default(0),
    netProfitMargin: z.number().default(0),
    returnOnInvestment: z.number().default(0),
    unitsSold: z.number().default(0),
    unitsRemaining: z.number().default(0),
    daysToSell: z.number().default(0),
    units: z.number().default(0),
    weight: z.number().default(0),
    pallets: z.number().default(0),
  }),
  // Bare ping, same contract as SalesOrderChannel.expensesUpdated: data-free on purpose.
  expensesUpdated: z.object({ purchaseOrderId: z.number() }),
} as const;

export const PurchaseOrderChannel: Channel<number, typeof PurchaseOrderChannelSchema> = {
  getChannelId: (id) => `purchaseOrder:${id}`,
  topics: { metricsUpdated: 'metricsUpdated', expensesUpdated: 'expensesUpdated' },
  schemas: PurchaseOrderChannelSchema,
};
